import {
  ApiLegacyCustomElementResponse,
  ApiTransitionElementResponse,
  ApiTransitionStoryGroupResponse,
} from '../../../../../../api/core/models';

export const isLegacyCustomElement = (
  t: ApiTransitionElementResponse | ApiTransitionStoryGroupResponse | ApiLegacyCustomElementResponse
): t is ApiLegacyCustomElementResponse => (t as ApiLegacyCustomElementResponse).data !== undefined;
